import { render } from "./RoamientoIndustrial.vue?vue&type=template&id=0dab3fbf&scoped=true"
import script from "./RoamientoIndustrial.vue?vue&type=script&lang=js"
export * from "./RoamientoIndustrial.vue?vue&type=script&lang=js"

import "./RoamientoIndustrial.vue?vue&type=style&index=0&id=0dab3fbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dab3fbf"]])

export default __exports__